// #region Party status type IDs (from status_types seed - category_id = 10)
export const PARTY_STATUS = {
    ACTIVE: 1,
    INACTIVE: 2,
    SUSPENDED: 3,
    PENDING_VERIFICATION: 4,
    PROSPECT_PENDING: 5,
    PROSPECT_FAILED: 6,
};
// Reverse mapping: ID -> Key name
export const PARTY_STATUS_KEYS = {
    1: 'ACTIVE',
    2: 'INACTIVE',
    3: 'SUSPENDED',
    4: 'PENDING_VERIFICATION',
    5: 'PROSPECT_PENDING',
    6: 'PROSPECT_FAILED',
};
// Human-readable display names
export const PARTY_STATUS_DISPLAY = {
    [PARTY_STATUS.ACTIVE]: 'Active',
    [PARTY_STATUS.INACTIVE]: 'Inactive',
    [PARTY_STATUS.SUSPENDED]: 'Suspended',
    [PARTY_STATUS.PENDING_VERIFICATION]: 'Pending Verification',
    [PARTY_STATUS.PROSPECT_PENDING]: 'Prospect Pending',
    [PARTY_STATUS.PROSPECT_FAILED]: 'Prospect Failed',
};
// #endregion
// #region Party relationship status type IDs (from status_types seed - category_id = 20)
export const PARTY_RELATIONSHIP_STATUS = {
    ACTIVE: 20,
    INACTIVE: 21,
    PENDING_APPROVAL: 22,
    APPROVED: 23,
    SUSPENDED: 24,
    TERMINATED: 25,
    PENDING_SETUP: 26,
    SETUP_COMPLETE: 27,
    PENDING_VERIFICATION: 28,
    VERIFIED: 29,
    REJECTED: 30,
    EXPIRED: 31,
};
// Reverse mapping: ID -> Key name
export const PARTY_RELATIONSHIP_STATUS_KEYS = {
    20: 'ACTIVE',
    21: 'INACTIVE',
    22: 'PENDING_APPROVAL',
    23: 'APPROVED',
    24: 'SUSPENDED',
    25: 'TERMINATED',
    26: 'PENDING_SETUP',
    27: 'SETUP_COMPLETE',
    28: 'PENDING_VERIFICATION',
    29: 'VERIFIED',
    30: 'REJECTED',
    31: 'EXPIRED',
};
// Human-readable display names
export const PARTY_RELATIONSHIP_STATUS_DISPLAY = {
    [PARTY_RELATIONSHIP_STATUS.ACTIVE]: 'Active',
    [PARTY_RELATIONSHIP_STATUS.INACTIVE]: 'Inactive',
    [PARTY_RELATIONSHIP_STATUS.PENDING_APPROVAL]: 'Pending Approval',
    [PARTY_RELATIONSHIP_STATUS.APPROVED]: 'Approved',
    [PARTY_RELATIONSHIP_STATUS.SUSPENDED]: 'Suspended',
    [PARTY_RELATIONSHIP_STATUS.TERMINATED]: 'Terminated',
    [PARTY_RELATIONSHIP_STATUS.PENDING_SETUP]: 'Pending Setup',
    [PARTY_RELATIONSHIP_STATUS.SETUP_COMPLETE]: 'Setup Complete',
    [PARTY_RELATIONSHIP_STATUS.PENDING_VERIFICATION]: 'Pending Verification',
    [PARTY_RELATIONSHIP_STATUS.VERIFIED]: 'Verified',
    [PARTY_RELATIONSHIP_STATUS.REJECTED]: 'Rejected',
    [PARTY_RELATIONSHIP_STATUS.EXPIRED]: 'Expired',
};
// #endregion
// #region Party relationship detail status type IDs (from status_types seed - category_id = 30)
export const PARTY_RELATIONSHIP_DETAIL_STATUS = {
    DRAFT: 40,
    PENDING_APPROVAL: 41,
    APPROVED: 42,
    ACTIVE: 43,
    SUSPENDED: 44,
    EXPIRED: 45,
    REJECTED: 46,
    PENDING_VERIFICATION: 47,
    VERIFICATION_FAILED: 48,
    PENDING_SETUP: 49,
    SETUP_COMPLETE: 50,
    CANCELLED: 51,
    PENDING_RENEWAL: 52,
    ARCHIVED: 53,
};
// Reverse mapping: ID -> Key name
export const PARTY_RELATIONSHIP_DETAIL_STATUS_KEYS = {
    40: 'DRAFT',
    41: 'PENDING_APPROVAL',
    42: 'APPROVED',
    43: 'ACTIVE',
    44: 'SUSPENDED',
    45: 'EXPIRED',
    46: 'REJECTED',
    47: 'PENDING_VERIFICATION',
    48: 'VERIFICATION_FAILED',
    49: 'PENDING_SETUP',
    50: 'SETUP_COMPLETE',
    51: 'CANCELLED',
    52: 'PENDING_RENEWAL',
    53: 'ARCHIVED',
};
// Human-readable display names
export const PARTY_RELATIONSHIP_DETAIL_STATUS_DISPLAY = {
    [PARTY_RELATIONSHIP_DETAIL_STATUS.DRAFT]: 'Draft',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.PENDING_APPROVAL]: 'Pending Approval',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.APPROVED]: 'Approved',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.ACTIVE]: 'Active',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.SUSPENDED]: 'Suspended',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.EXPIRED]: 'Expired',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.REJECTED]: 'Rejected',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.PENDING_VERIFICATION]: 'Pending Verification',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.VERIFICATION_FAILED]: 'Verification Failed',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.PENDING_SETUP]: 'Pending Setup',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.SETUP_COMPLETE]: 'Setup Complete',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.CANCELLED]: 'Cancelled',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.PENDING_RENEWAL]: 'Pending Renewal',
    [PARTY_RELATIONSHIP_DETAIL_STATUS.ARCHIVED]: 'Archived',
};
// #endregion
// region Party event status type IDs (from status_types seed - category_id = 60)
export const PARTY_EVENT_STATUS = {
    SUCCESS: 60,
    FAILURE: 61,
    PENDING: 62,
    SKIPPED: 63,
    TIMEOUT: 64,
    WARNING: 65,
};
// Reverse mapping: ID -> Key name
export const PARTY_EVENT_STATUS_KEYS = {
    60: 'SUCCESS',
    61: 'FAILURE',
    62: 'PENDING',
    63: 'SKIPPED',
    64: 'TIMEOUT',
    65: 'WARNING',
};
// Human-readable display names
export const PARTY_EVENT_STATUS_DISPLAY = {
    [PARTY_EVENT_STATUS.SUCCESS]: 'Success',
    [PARTY_EVENT_STATUS.FAILURE]: 'Failure',
    [PARTY_EVENT_STATUS.PENDING]: 'Pending',
    [PARTY_EVENT_STATUS.SKIPPED]: 'Skipped',
    [PARTY_EVENT_STATUS.TIMEOUT]: 'Timeout',
    [PARTY_EVENT_STATUS.WARNING]: 'Warning',
};
// #endregion
// #region File status type IDs (from status_types seed - category_id = 80)
export const FILE_STATUS = {
    PENDING: 80,
    RECEIVED: 81,
    VALIDATING: 82,
    PROCESSING: 83,
    COMPLETED: 84,
    PROCESSED: 85,
    FAILED: 86,
    REJECTED: 87,
    NEEDS_REVIEW: 88,
    WAITING_FOR_APPROVAL: 89,
    APPROVED: 90,
    DISAPPROVED: 91,
    AWAITING_FUNDS: 92,
    FUNDS_RECEIVED: 93,
    READY_FOR_RELEASE: 94,
    RELEASED: 95,
    CANCELLED: 96,
    RELEASE_FAILED: 97,
    RELEASE_RETRYING: 98,
    RELEASE_SENDING: 99,
};
/**
 * File statuses that indicate an approved-or-beyond state for payment files.
 * Used by the Payment File Ledger report to determine which files are eligible.
 * Includes pre-approval statuses (WAITING_FOR_APPROVAL) and funding lifecycle
 * statuses (AWAITING_FUNDS, FUNDS_RECEIVED) so approved payment files appear
 * even when a disbursement file has not yet been created.
 */
export const APPROVED_FILE_STATUSES = [
    FILE_STATUS.COMPLETED,
    FILE_STATUS.WAITING_FOR_APPROVAL,
    FILE_STATUS.APPROVED,
    FILE_STATUS.AWAITING_FUNDS,
    FILE_STATUS.FUNDS_RECEIVED,
    FILE_STATUS.READY_FOR_RELEASE,
    FILE_STATUS.RELEASED,
];
// Reverse mapping: ID -> Key name
export const FILE_STATUS_KEYS = {
    80: 'PENDING',
    81: 'RECEIVED',
    82: 'VALIDATING',
    83: 'PROCESSING',
    84: 'COMPLETED',
    85: 'PROCESSED',
    86: 'FAILED',
    87: 'REJECTED',
    88: 'NEEDS_REVIEW',
    89: 'WAITING_FOR_APPROVAL',
    90: 'APPROVED',
    91: 'DISAPPROVED',
    92: 'AWAITING_FUNDS',
    93: 'FUNDS_RECEIVED',
    94: 'READY_FOR_RELEASE',
    95: 'RELEASED',
    96: 'CANCELLED',
    97: 'RELEASE_FAILED',
    98: 'RELEASE_RETRYING',
    99: 'RELEASE_SENDING',
};
// Human-readable display names
export const FILE_STATUS_DISPLAY = {
    [FILE_STATUS.PENDING]: 'Pending',
    [FILE_STATUS.RECEIVED]: 'Received',
    [FILE_STATUS.VALIDATING]: 'Validating',
    [FILE_STATUS.PROCESSING]: 'Processing',
    [FILE_STATUS.COMPLETED]: 'Completed',
    [FILE_STATUS.PROCESSED]: 'Processed',
    [FILE_STATUS.FAILED]: 'Failed',
    [FILE_STATUS.REJECTED]: 'Rejected',
    [FILE_STATUS.NEEDS_REVIEW]: 'Needs Review',
    [FILE_STATUS.WAITING_FOR_APPROVAL]: 'Waiting for Approval',
    [FILE_STATUS.APPROVED]: 'Approved',
    [FILE_STATUS.DISAPPROVED]: 'Disapproved',
    [FILE_STATUS.AWAITING_FUNDS]: 'Awaiting Funds',
    [FILE_STATUS.FUNDS_RECEIVED]: 'Funds Received',
    [FILE_STATUS.READY_FOR_RELEASE]: 'Ready for Release',
    [FILE_STATUS.RELEASED]: 'Released',
    [FILE_STATUS.CANCELLED]: 'Cancelled',
    [FILE_STATUS.RELEASE_FAILED]: 'Release Failed',
    [FILE_STATUS.RELEASE_RETRYING]: 'Retrying',
    [FILE_STATUS.RELEASE_SENDING]: 'Sending',
};
// #endregion
// #region Seeded file format IDs (from file_formats seed)
/** Known seeded file_formats.id values used by payment processing / reissue. */
export const FILE_FORMAT = {
    PAYMENT_EXPORT_CSV_V1: 2,
    BDO_PAYMENT_CSV_V1: 4,
};
// #endregion
// #region Account status type IDs (from status_types seed - category_id = 50)
export const ACCOUNT_STATUS = {
    ACTIVE: 100,
    INACTIVE: 101,
    SUSPENDED: 102,
    CLOSED: 103,
    UNVERIFIED: 104,
    PENDING_VERIFICATION: 105,
    VERIFIED: 106,
};
// Reverse mapping: ID -> Key name
export const ACCOUNT_STATUS_KEYS = {
    100: 'ACTIVE',
    101: 'INACTIVE',
    102: 'SUSPENDED',
    103: 'CLOSED',
    104: 'UNVERIFIED',
    105: 'PENDING_VERIFICATION',
    106: 'VERIFIED',
};
// Human-readable display names
export const ACCOUNT_STATUS_DISPLAY = {
    [ACCOUNT_STATUS.ACTIVE]: 'Active',
    [ACCOUNT_STATUS.INACTIVE]: 'Inactive',
    [ACCOUNT_STATUS.SUSPENDED]: 'Suspended',
    [ACCOUNT_STATUS.CLOSED]: 'Closed',
    [ACCOUNT_STATUS.UNVERIFIED]: 'Unverified',
    [ACCOUNT_STATUS.PENDING_VERIFICATION]: 'Pending Verification',
    [ACCOUNT_STATUS.VERIFIED]: 'Verified',
};
// #endregion
// #region Integration profile status type IDs (from status_types seed - entity_type_id = 20)
export const INTEGRATION_PROFILE_STATUS = {
    ACTIVE: 120,
    INACTIVE: 121,
    PENDING: 122,
};
// Reverse mapping: ID -> Key name
export const INTEGRATION_PROFILE_STATUS_KEYS = {
    120: 'ACTIVE',
    121: 'INACTIVE',
    122: 'PENDING',
};
// #endregion
// #region Payment status type IDs (from status_types seed - category_id = 140)
export const PAYMENT_STATUS = {
    CREATED: 140,
    PROCESSING: 141,
    PENDING_APPROVAL: 142,
    APPROVED: 143,
    AWAITING_FUNDS: 144,
    FUNDS_RECEIVED: 145,
    PENDING_RELEASE: 146,
    RELEASED: 147,
    FAILED: 148,
    CANCELLED: 149,
    EXPIRED: 150,
    PENDING: 151,
    REJECTED: 152,
    REFUNDED: 153,
    ISSUED: 154,
    RETURNED: 155,
    STOPPED: 156,
    COMPLETED: 157,
    REISSUED: 158,
};
// Reverse mapping: ID -> Key name
export const PAYMENT_STATUS_KEYS = {
    140: 'CREATED',
    141: 'PROCESSING',
    142: 'PENDING_APPROVAL',
    143: 'APPROVED',
    144: 'AWAITING_FUNDS',
    145: 'FUNDS_RECEIVED',
    146: 'PENDING_RELEASE',
    147: 'RELEASED',
    148: 'FAILED',
    149: 'CANCELLED',
    150: 'EXPIRED',
    151: 'PENDING',
    152: 'REJECTED',
    153: 'REFUNDED',
    154: 'ISSUED',
    155: 'RETURNED',
    156: 'STOPPED',
    157: 'COMPLETED',
    158: 'REISSUED',
};
// Human-readable display names
export const PAYMENT_STATUS_DISPLAY = {
    [PAYMENT_STATUS.CREATED]: 'Created',
    [PAYMENT_STATUS.PROCESSING]: 'Processing',
    [PAYMENT_STATUS.PENDING_APPROVAL]: 'Pending Approval',
    [PAYMENT_STATUS.APPROVED]: 'Approved',
    [PAYMENT_STATUS.AWAITING_FUNDS]: 'Awaiting Funds',
    [PAYMENT_STATUS.FUNDS_RECEIVED]: 'Funds Received',
    [PAYMENT_STATUS.PENDING_RELEASE]: 'Pending Release',
    [PAYMENT_STATUS.RELEASED]: 'Released',
    [PAYMENT_STATUS.FAILED]: 'Failed',
    [PAYMENT_STATUS.CANCELLED]: 'Cancelled',
    [PAYMENT_STATUS.EXPIRED]: 'Expired',
    [PAYMENT_STATUS.PENDING]: 'Pending',
    [PAYMENT_STATUS.REJECTED]: 'Rejected',
    [PAYMENT_STATUS.REFUNDED]: 'Refunded',
    [PAYMENT_STATUS.ISSUED]: 'Issued',
    [PAYMENT_STATUS.RETURNED]: 'Returned',
    [PAYMENT_STATUS.STOPPED]: 'Stopped',
    [PAYMENT_STATUS.COMPLETED]: 'Completed',
    [PAYMENT_STATUS.REISSUED]: 'Reissued',
};
/**
 * Payment status IDs shown in payment list filters.
 * Uses only {@link PAYMENT_STATUS} values from `status_types` (entity_type_id = 140).
 *
 * Excludes:
 * - {@link PAYMENT_STATUS.CREATED} — initial row state, not useful for discovery.
 * - {@link PAYMENT_STATUS.PENDING_RELEASE} — still on `payments.status_id`, but is the
 *   “awaiting release” handoff; disbursement/file views usually own that stage. Grid still shows it.
 *
 * {@link PAYMENT_STATUS.RELEASED} and {@link PAYMENT_STATUS.REISSUED} remain in the
 * filter; labels use {@link PAYMENT_STATUS_DISPLAY}.
 */
export const PAYMENT_STATUS_FILTER_ORDER = [
    'PROCESSING',
    'PENDING_APPROVAL',
    'APPROVED',
    'AWAITING_FUNDS',
    'FUNDS_RECEIVED',
    'RELEASED',
    'REISSUED',
    'FAILED',
    'CANCELLED',
    'EXPIRED',
    'PENDING',
    'REJECTED',
    'REFUNDED',
    'STOPPED',
    'COMPLETED',
];
export const PAYMENT_STATUS_FILTER_IDS = PAYMENT_STATUS_FILTER_ORDER.map((key) => PAYMENT_STATUS[key]);
export const RECEIPT_TRIGGER_STATUS = PAYMENT_STATUS.COMPLETED;
// #endregion
// #region Payment instruction status type IDs (from status_types seed - category_id = 160)
export const PAYMENT_INSTRUCTION_STATUS = {
    PENDING: 160,
    RELEASED: 161,
    ON_HOLD: 162,
    SETTLED: 163,
    FAILED: 164,
    CANCELLED: 165,
    REJECTED: 166,
    LOADED: 167,
};
// Reverse mapping: ID -> Key name
export const PAYMENT_INSTRUCTION_STATUS_KEYS = {
    160: 'PENDING',
    161: 'RELEASED',
    162: 'ON_HOLD',
    163: 'SETTLED',
    164: 'FAILED',
    165: 'CANCELLED',
    166: 'REJECTED',
    167: 'LOADED',
};
// Human-readable display names
export const PAYMENT_INSTRUCTION_STATUS_DISPLAY = {
    [PAYMENT_INSTRUCTION_STATUS.PENDING]: 'Pending',
    [PAYMENT_INSTRUCTION_STATUS.RELEASED]: 'Released',
    [PAYMENT_INSTRUCTION_STATUS.ON_HOLD]: 'On Hold',
    [PAYMENT_INSTRUCTION_STATUS.SETTLED]: 'Settled',
    [PAYMENT_INSTRUCTION_STATUS.FAILED]: 'Failed',
    [PAYMENT_INSTRUCTION_STATUS.CANCELLED]: 'Cancelled',
    [PAYMENT_INSTRUCTION_STATUS.REJECTED]: 'Rejected',
    [PAYMENT_INSTRUCTION_STATUS.LOADED]: 'Loaded',
};
// #endregion
// #region Dash webhook constants
export const DASH_WEBHOOK_EVENT = {
    CARD_STATUS_CHANGE: 'card.status.change',
    CARD_REPLACEMENT: 'card.replacement',
};
export const DASH_CARD_STATUS = {
    ACTIVE: 'active',
    CLOSED: 'closed',
    LOST: 'lost',
    REPLACED: 'replaced',
    SUSPENDED: 'suspended',
    EXPIRED: 'expired',
    PFRAUD: 'pfraud',
    FRAUD: 'fraud',
};
// #endregion
// #region Party relationship type IDs (from party_relationship_types table)
export const PARTY_RELATIONSHIP_TYPE = {
    CLIENT_SUPPLIER: 1,
    PARENT_CHILD: 2,
    PARTNERSHIP: 3,
    CLIENT_PROVIDER: 4,
    CORRESPONDENT_BANK: 5,
    AFFILIATE: 6,
    AGENT: 7,
    RESELLER: 8,
    INTEGRATION_PARTNER: 9,
    COMPLIANCE_RELATIONSHIP: 10,
    BENEFICIARY: 11,
};
// Reverse mapping: ID -> Key name
export const PARTY_RELATIONSHIP_TYPE_KEYS = {
    1: 'CLIENT_SUPPLIER',
    2: 'PARENT_CHILD',
    3: 'PARTNERSHIP',
    4: 'CLIENT_PROVIDER',
    5: 'CORRESPONDENT_BANK',
    6: 'AFFILIATE',
    7: 'AGENT',
    8: 'RESELLER',
    9: 'INTEGRATION_PARTNER',
    10: 'COMPLIANCE_RELATIONSHIP',
    11: 'BENEFICIARY',
};
// Human-readable display names
export const PARTY_RELATIONSHIP_TYPE_DISPLAY = {
    [PARTY_RELATIONSHIP_TYPE.CLIENT_SUPPLIER]: 'Client-Supplier',
    [PARTY_RELATIONSHIP_TYPE.PARENT_CHILD]: 'Parent-Child',
    [PARTY_RELATIONSHIP_TYPE.PARTNERSHIP]: 'Partnership',
    [PARTY_RELATIONSHIP_TYPE.CLIENT_PROVIDER]: 'Client-Provider',
    [PARTY_RELATIONSHIP_TYPE.CORRESPONDENT_BANK]: 'Correspondent Bank',
    [PARTY_RELATIONSHIP_TYPE.AFFILIATE]: 'Affiliate',
    [PARTY_RELATIONSHIP_TYPE.AGENT]: 'Agent',
    [PARTY_RELATIONSHIP_TYPE.RESELLER]: 'Reseller',
    [PARTY_RELATIONSHIP_TYPE.INTEGRATION_PARTNER]: 'Integration Partner',
    [PARTY_RELATIONSHIP_TYPE.COMPLIANCE_RELATIONSHIP]: 'Compliance Relationship',
    [PARTY_RELATIONSHIP_TYPE.BENEFICIARY]: 'Beneficiary',
};
// #endregion
// #region Party relationship detail type IDs (from party_relationship_detail_types table)
export const PARTY_RELATIONSHIP_DETAIL_TYPE = {
    SUPPLIER_ID: 1,
    VENDOR_NUMBER: 2,
    SUPPLIER_CODE: 3,
    TAX_ID: 4,
    CUSTOMER_ID: 5,
    CUSTOMER_CODE: 6,
    ACCOUNT_NUMBER: 7,
    CONTRACT_NUMBER: 8,
    PARTNER_ID: 9,
    PARTNERSHIP_AGREEMENT: 10,
    AFFILIATE_CODE: 11,
    COMMISSION_ID: 12,
    INTEGRATION_ID: 13,
    API_KEY_ID: 14,
    CORRESPONDENT_CODE: 15,
    SWIFT_CODE: 16,
    CORRESPONDENT_ACCOUNT: 17,
    AGENT_ID: 18,
    AGENT_LICENSE: 19,
    REFERENCE_NUMBER: 20,
    EXTERNAL_ID: 21,
    DUNS_NUMBER: 22,
};
// Reverse mapping: ID -> Key name
export const PARTY_RELATIONSHIP_DETAIL_TYPE_KEYS = {
    1: 'SUPPLIER_ID',
    2: 'VENDOR_NUMBER',
    3: 'SUPPLIER_CODE',
    4: 'TAX_ID',
    5: 'CUSTOMER_ID',
    6: 'CUSTOMER_CODE',
    7: 'ACCOUNT_NUMBER',
    8: 'CONTRACT_NUMBER',
    9: 'PARTNER_ID',
    10: 'PARTNERSHIP_AGREEMENT',
    11: 'AFFILIATE_CODE',
    12: 'COMMISSION_ID',
    13: 'INTEGRATION_ID',
    14: 'API_KEY_ID',
    15: 'CORRESPONDENT_CODE',
    16: 'SWIFT_CODE',
    17: 'CORRESPONDENT_ACCOUNT',
    18: 'AGENT_ID',
    19: 'AGENT_LICENSE',
    20: 'REFERENCE_NUMBER',
    21: 'EXTERNAL_ID',
    22: 'DUNS_NUMBER',
};
// Human-readable display names
export const PARTY_RELATIONSHIP_DETAIL_TYPE_DISPLAY = {
    [PARTY_RELATIONSHIP_DETAIL_TYPE.SUPPLIER_ID]: 'Supplier ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.VENDOR_NUMBER]: 'Vendor Number',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.SUPPLIER_CODE]: 'Supplier Code',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.TAX_ID]: 'Tax ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.CUSTOMER_ID]: 'Customer ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.CUSTOMER_CODE]: 'Customer Code',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.ACCOUNT_NUMBER]: 'Account Number',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.CONTRACT_NUMBER]: 'Contract Number',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.PARTNER_ID]: 'Partner ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.PARTNERSHIP_AGREEMENT]: 'Partnership Agreement',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.AFFILIATE_CODE]: 'Affiliate Code',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.COMMISSION_ID]: 'Commission ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.INTEGRATION_ID]: 'Integration ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.API_KEY_ID]: 'API Key ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.CORRESPONDENT_CODE]: 'Correspondent Code',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.SWIFT_CODE]: 'SWIFT Code',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.CORRESPONDENT_ACCOUNT]: 'Correspondent Account',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.AGENT_ID]: 'Agent ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.AGENT_LICENSE]: 'Agent License',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.REFERENCE_NUMBER]: 'Reference Number',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.EXTERNAL_ID]: 'External ID',
    [PARTY_RELATIONSHIP_DETAIL_TYPE.DUNS_NUMBER]: 'DUNS Number',
};
// #endregion
// #region Party relationship approval type IDs (from party_relationship_approval_types table)
export const PARTY_RELATIONSHIP_APPROVAL_TYPE = {
    IN_PROGRESS: 1,
    APPROVED: 2,
    DENIED: 3,
};
// Reverse mapping: ID -> Key name
export const PARTY_RELATIONSHIP_APPROVAL_TYPE_KEYS = {
    1: 'IN_PROGRESS',
    2: 'APPROVED',
    3: 'DENIED',
};
// Human-readable display names
export const PARTY_RELATIONSHIP_APPROVAL_TYPE_DISPLAY = {
    [PARTY_RELATIONSHIP_APPROVAL_TYPE.IN_PROGRESS]: 'In Progress',
    [PARTY_RELATIONSHIP_APPROVAL_TYPE.APPROVED]: 'Approved',
    [PARTY_RELATIONSHIP_APPROVAL_TYPE.DENIED]: 'Denied',
};
// #endregion
// #region Account type IDs (from account_types table)
export const ACCOUNT_TYPE = {
    CHECKING: 1,
    SAVINGS: 2,
    CREDIT_CARD: 3,
    DEBIT_CARD: 4,
    WALLET: 5,
    WIRE_ACCOUNT: 6,
    ACH_ACCOUNT: 7,
    CRYPTO_WALLET: 8,
    PREPAID_CARD: 9,
    BUSINESS_ACCOUNT: 10,
    CHECK: 11,
};
// Reverse mapping: ID -> Key name
export const ACCOUNT_TYPE_KEYS = {
    1: 'CHECKING',
    2: 'SAVINGS',
    3: 'CREDIT_CARD',
    4: 'DEBIT_CARD',
    5: 'WALLET',
    6: 'WIRE_ACCOUNT',
    7: 'ACH_ACCOUNT',
    8: 'CRYPTO_WALLET',
    9: 'PREPAID_CARD',
    10: 'BUSINESS_ACCOUNT',
    11: 'CHECK',
};
// Human-readable display names
export const ACCOUNT_TYPE_DISPLAY = {
    [ACCOUNT_TYPE.CHECKING]: 'Checking',
    [ACCOUNT_TYPE.SAVINGS]: 'Savings',
    [ACCOUNT_TYPE.CREDIT_CARD]: 'Credit Card',
    [ACCOUNT_TYPE.DEBIT_CARD]: 'Debit Card',
    [ACCOUNT_TYPE.WALLET]: 'Wallet',
    [ACCOUNT_TYPE.WIRE_ACCOUNT]: 'Wire Account',
    [ACCOUNT_TYPE.ACH_ACCOUNT]: 'ACH Account',
    [ACCOUNT_TYPE.CRYPTO_WALLET]: 'Crypto Wallet',
    [ACCOUNT_TYPE.PREPAID_CARD]: 'Prepaid Card',
    [ACCOUNT_TYPE.BUSINESS_ACCOUNT]: 'Business Account',
    [ACCOUNT_TYPE.CHECK]: 'Check',
};
// #endregion
/**
 * Email type IDs (from email_types table)
 */
export const EMAIL_TYPE = {
    BUSINESS_MAIN: 1,
};
// #region File type IDs (from file_types table)
export const FILE_TYPE = {
    PAYMENT: 1,
    DISBURSEMENT: 2,
    RETURN: 3,
    ACK: 4,
    RECONCILIATION: 5,
    REPORT: 6,
    MVF: 7,
    CORRECTION: 8,
    SUPPLIER: 9,
    INTERNAL_REPORT: 10,
};
// Reverse mapping: ID -> Key name
export const FILE_TYPE_KEYS = {
    1: 'PAYMENT',
    2: 'DISBURSEMENT',
    3: 'RETURN',
    4: 'ACK',
    5: 'RECONCILIATION',
    6: 'REPORT',
    7: 'MVF',
    8: 'CORRECTION',
    9: 'SUPPLIER',
    10: 'INTERNAL_REPORT',
};
// Human-readable display names
export const FILE_TYPE_DISPLAY = {
    [FILE_TYPE.PAYMENT]: 'Payment',
    [FILE_TYPE.DISBURSEMENT]: 'Disbursement',
    [FILE_TYPE.RETURN]: 'Return',
    [FILE_TYPE.ACK]: 'Acknowledgment',
    [FILE_TYPE.RECONCILIATION]: 'Reconciliation',
    [FILE_TYPE.REPORT]: 'Report',
    [FILE_TYPE.MVF]: 'MVF',
    [FILE_TYPE.CORRECTION]: 'Correction',
    [FILE_TYPE.SUPPLIER]: 'Supplier',
    [FILE_TYPE.INTERNAL_REPORT]: 'Internal Report',
};
// #endregion
// #region Origination Method IDs (from origination_methods table)
export const ORIGINATION_METHOD = {
    API: 1,
    BATCH_FILE: 2,
    MANUAL: 3,
    WEBHOOK: 4,
    RECURRING: 5,
    MOBILE_APP: 6,
    WEB_PORTAL: 7,
    IMPORT: 8,
    SYSTEM_GENERATED: 9,
};
// Reverse mapping: ID -> Key name
export const ORIGINATION_METHOD_KEYS = {
    1: 'API',
    2: 'BATCH_FILE',
    3: 'MANUAL',
    4: 'WEBHOOK',
    5: 'RECURRING',
    6: 'MOBILE_APP',
    7: 'WEB_PORTAL',
    8: 'IMPORT',
    9: 'SYSTEM_GENERATED',
};
// Human-readable display names
export const ORIGINATION_METHOD_DISPLAY = {
    [ORIGINATION_METHOD.API]: 'API',
    [ORIGINATION_METHOD.BATCH_FILE]: 'Batch File',
    [ORIGINATION_METHOD.MANUAL]: 'Manual',
    [ORIGINATION_METHOD.WEBHOOK]: 'Webhook',
    [ORIGINATION_METHOD.RECURRING]: 'Recurring',
    [ORIGINATION_METHOD.MOBILE_APP]: 'Mobile App',
    [ORIGINATION_METHOD.WEB_PORTAL]: 'Web Portal',
    [ORIGINATION_METHOD.IMPORT]: 'Import',
    [ORIGINATION_METHOD.SYSTEM_GENERATED]: 'System Generated',
};
// #endregion
// #region Entity type IDs (from entity_types table)
export const ENTITY_TYPE = {
    PARTY: 1,
    PARTY_RELATIONSHIP: 2,
    PARTY_RELATIONSHIP_DETAIL: 3,
    PARTY_EVENT: 4,
    INTEGRATION_PROFILE: 20,
    INTEGRATION_PROFILE_EVENT: 21,
    IMPLEMENTATION: 40,
    IMPLEMENTATION_STEP: 41,
    IMPLEMENTATION_EVENT: 42,
    FILE: 60,
    FILE_BATCH: 61,
    FILE_EVENT: 62,
    FILE_FORMAT: 63,
    ACCOUNT: 80,
    PARTNER: 100,
    WORKFLOW_CONFIGURATION: 120,
    WORKFLOW_STEP: 121,
    WORKFLOW_EVENT: 122,
    PAYMENT: 140,
    PAYMENT_INSTRUCTION: 141,
    PAYMENT_INSTRUCTION_PARTICIPANT: 142,
    PAYMENT_ITEM: 143,
    PROVIDER: 160,
    RECONCILIATION_BANK_STATEMENT: 170,
};
// Reverse mapping: ID -> Key name
export const ENTITY_TYPE_KEYS = {
    1: 'PARTY',
    2: 'PARTY_RELATIONSHIP',
    3: 'PARTY_RELATIONSHIP_DETAIL',
    4: 'PARTY_EVENT',
    20: 'INTEGRATION_PROFILE',
    21: 'INTEGRATION_PROFILE_EVENT',
    40: 'IMPLEMENTATION',
    41: 'IMPLEMENTATION_STEP',
    42: 'IMPLEMENTATION_EVENT',
    60: 'FILE',
    61: 'FILE_BATCH',
    62: 'FILE_EVENT',
    63: 'FILE_FORMAT',
    80: 'ACCOUNT',
    100: 'PARTNER',
    120: 'WORKFLOW_CONFIGURATION',
    121: 'WORKFLOW_STEP',
    122: 'WORKFLOW_EVENT',
    140: 'PAYMENT',
    141: 'PAYMENT_INSTRUCTION',
    142: 'PAYMENT_INSTRUCTION_PARTICIPANT',
    143: 'PAYMENT_ITEM',
    160: 'PROVIDER',
    170: 'RECONCILIATION_BANK_STATEMENT',
};
// Human-readable display names
export const ENTITY_TYPE_DISPLAY = {
    [ENTITY_TYPE.PARTY]: 'Party',
    [ENTITY_TYPE.PARTY_RELATIONSHIP]: 'Party Relationship',
    [ENTITY_TYPE.PARTY_RELATIONSHIP_DETAIL]: 'Party Relationship Detail',
    [ENTITY_TYPE.PARTY_EVENT]: 'Party Event',
    [ENTITY_TYPE.INTEGRATION_PROFILE]: 'Integration Profile',
    [ENTITY_TYPE.INTEGRATION_PROFILE_EVENT]: 'Integration Profile Event',
    [ENTITY_TYPE.IMPLEMENTATION]: 'Implementation',
    [ENTITY_TYPE.IMPLEMENTATION_STEP]: 'Implementation Step',
    [ENTITY_TYPE.IMPLEMENTATION_EVENT]: 'Implementation Event',
    [ENTITY_TYPE.FILE]: 'File',
    [ENTITY_TYPE.FILE_BATCH]: 'File Batch',
    [ENTITY_TYPE.FILE_EVENT]: 'File Event',
    [ENTITY_TYPE.FILE_FORMAT]: 'File Format',
    [ENTITY_TYPE.ACCOUNT]: 'Account',
    [ENTITY_TYPE.PARTNER]: 'Partner',
    [ENTITY_TYPE.WORKFLOW_CONFIGURATION]: 'Workflow Configuration',
    [ENTITY_TYPE.WORKFLOW_STEP]: 'Workflow Step',
    [ENTITY_TYPE.WORKFLOW_EVENT]: 'Workflow Event',
    [ENTITY_TYPE.PAYMENT]: 'Payment',
    [ENTITY_TYPE.PAYMENT_INSTRUCTION]: 'Payment Instruction',
    [ENTITY_TYPE.PAYMENT_INSTRUCTION_PARTICIPANT]: 'Payment Instruction Participant',
    [ENTITY_TYPE.PAYMENT_ITEM]: 'Payment Item',
    [ENTITY_TYPE.PROVIDER]: 'Provider',
    [ENTITY_TYPE.RECONCILIATION_BANK_STATEMENT]: 'Reconciliation Bank Statement',
};
// #endregion
export const ADDRESS_TYPE = {
    PRIMARY: 1,
};
export const CONTACT_TYPE = {
    GENERAL: 1,
    PRIMARY: 2,
    BILLING: 3,
    TECHNICAL: 4,
    EXECUTIVE: 5,
    ACCOUNTING: 6,
    OPERATIONS: 7,
    LEGAL: 8,
    EMERGENCY: 9,
};
export const CONTENT_TYPE = {
    PDF: 1,
    DOC: 2,
    DOCX: 3,
    TXT: 4,
    XLS: 10,
    XLSX: 11,
    CSV: 12,
    JPEG: 20,
    PNG: 21,
    GIF: 22,
    TIFF: 23,
    ZIP: 30,
    RAR: 31,
    TAR: 32,
    JSON: 40,
    XML: 41,
    YAML: 42,
};
// Reverse mapping: ID -> Key name
export const CONTENT_TYPE_KEYS = {
    1: 'PDF',
    2: 'DOC',
    3: 'DOCX',
    4: 'TXT',
    10: 'XLS',
    11: 'XLSX',
    12: 'CSV',
    20: 'JPEG',
    21: 'PNG',
    22: 'GIF',
    23: 'TIFF',
    30: 'ZIP',
    31: 'RAR',
    32: 'TAR',
    40: 'JSON',
    41: 'XML',
    42: 'YAML',
};
export const COUNTRY_ALPHA2 = {
    US: 1,
    CA: 2,
    MX: 3,
    GB: 4,
    DE: 5,
    FR: 6,
    IT: 7,
    ES: 8,
    NL: 9,
    CH: 10,
    SE: 11,
    NO: 12,
    DK: 13,
    JP: 14,
    CN: 15,
    AU: 16,
    NZ: 17,
    SG: 18,
    HK: 19,
    KR: 20,
    IN: 21,
    BR: 22,
    AR: 23,
    CL: 24,
    CO: 25,
};
export const COUNTRY_ALPHA3 = {
    USA: 1,
    CAN: 2,
    MEX: 3,
    GBR: 4,
    DEU: 5,
    FRA: 6,
    ITA: 7,
    ESP: 8,
    NLD: 9,
    CHE: 10,
    SWE: 11,
    NOR: 12,
    DNK: 13,
    JPN: 14,
    CHN: 15,
    AUS: 16,
    NZL: 17,
    SGP: 18,
    HKG: 19,
    KOR: 20,
    IND: 21,
    BRA: 22,
    ARG: 23,
    CHL: 24,
    COL: 25,
};
export const CURRENCY = {
    USD: 1,
    EUR: 2,
    GBP: 3,
    JPY: 4,
    CAD: 5,
    AUD: 6,
    CHF: 7,
    CNY: 8,
    SEK: 9,
    NZD: 10,
    BTC: 11,
    ETH: 12,
    USDC: 13,
    USDT: 14,
    MXN: 15,
    BRL: 16,
    INR: 17,
    KRW: 18,
    SGD: 19,
    HKD: 20,
    NOK: 21,
    DKK: 22,
    CLP: 23,
    ARS: 24,
    COP: 25,
};
export const ENROLLMENT_CATEGORY = {
    STRATEGIC: 1,
    GENERAL: 2,
    BASIC: 3,
    NETWORK_MATCH: 4,
    EXEMPT: 10,
    INDIVIDUAL: 11,
    INTERNATIONAL: 12,
    PRIVATE: 13,
};
export const FILE_CATEGORY = {
    PAYMENT: 1,
    RECONCILIATION: 2,
    REPORT: 3,
    MASTER_DATA: 4,
};
export const HISTORY_CHANGE_TYPE = {
    CREATED: 1,
    UPDATED: 2,
    STATUS_CHANGED: 3,
    MERGED: 4,
    SPLIT: 5,
    ARCHIVED: 6,
    RESTORED: 7,
    MIGRATED: 8,
    ENRICHED: 9,
    CORRECTED: 10,
};
// #region Integration Type IDs (from integration_types table)
export const INTEGRATION_TYPE = {
    SFTP: 1,
    API: 2,
    WEBHOOK: 3,
};
// Reverse mapping: ID -> Key name
export const INTEGRATION_TYPE_KEYS = {
    1: 'SFTP',
    2: 'API',
    3: 'WEBHOOK',
};
// Human-readable display names
export const INTEGRATION_TYPE_DISPLAY = {
    [INTEGRATION_TYPE.SFTP]: 'SFTP',
    [INTEGRATION_TYPE.API]: 'API',
    [INTEGRATION_TYPE.WEBHOOK]: 'Webhook',
};
// #endregion
// #region Party type IDs (from party_types table)
export const PARTY_TYPE = {
    PERSON: 1,
    ORGANIZATION: 2,
    PROVIDER: 3,
    PARTNER: 4,
};
// Reverse mapping: ID -> Key name
export const PARTY_TYPE_KEYS = {
    1: 'PERSON',
    2: 'ORGANIZATION',
    3: 'PROVIDER',
    4: 'PARTNER',
};
// Human-readable display names
export const PARTY_TYPE_DISPLAY = {
    [PARTY_TYPE.PERSON]: 'Person',
    [PARTY_TYPE.ORGANIZATION]: 'Organization',
    [PARTY_TYPE.PROVIDER]: 'Provider',
    [PARTY_TYPE.PARTNER]: 'Partner',
};
// #endregion
// #region Party role IDs (from party_roles table)
export const PARTY_ROLE = {
    BUYER: 1,
    SUPPLIER: 2,
    CONSUMER: 3,
    BANK: 4,
    CARD_PROCESSOR: 5,
    NETWORK: 6,
    AFFILIATE: 7,
    PROSPECT: 8,
    INTERNAL: 9,
};
// Reverse mapping: ID -> Key name
export const PARTY_ROLE_KEYS = {
    1: 'BUYER',
    2: 'SUPPLIER',
    3: 'CONSUMER',
    4: 'BANK',
    5: 'CARD_PROCESSOR',
    6: 'NETWORK',
    7: 'AFFILIATE',
    8: 'PROSPECT',
    9: 'INTERNAL',
};
// Human-readable display names
export const PARTY_ROLE_DISPLAY = {
    [PARTY_ROLE.BUYER]: 'Buyer',
    [PARTY_ROLE.SUPPLIER]: 'Supplier',
    [PARTY_ROLE.CONSUMER]: 'Consumer',
    [PARTY_ROLE.BANK]: 'Bank',
    [PARTY_ROLE.CARD_PROCESSOR]: 'Card Processor',
    [PARTY_ROLE.NETWORK]: 'Network',
    [PARTY_ROLE.AFFILIATE]: 'Affiliate',
    [PARTY_ROLE.PROSPECT]: 'Prospect',
    [PARTY_ROLE.INTERNAL]: 'Internal',
};
// #endregion
// #region Payment Type IDs (from payment_types table)
export const PAYABLE_TYPE = {
    GENERAL: 1,
    INVOICE: 2,
    EXPENSE: 3,
    GRANT: 4,
    REFUND: 5,
    PAYROLL: 6,
    COMMISSION: 7,
    DIVIDEND: 8,
    TAX: 9,
    LOAN: 10,
    UTILITY: 11,
};
// Reverse mapping: ID -> Key name
export const PAYABLE_TYPE_KEYS = {
    1: 'GENERAL',
    2: 'INVOICE',
    3: 'EXPENSE',
    4: 'GRANT',
    5: 'REFUND',
    6: 'PAYROLL',
    7: 'COMMISSION',
    8: 'DIVIDEND',
    9: 'TAX',
    10: 'LOAN',
    11: 'UTILITY',
};
// Human-readable display names
export const PAYABLE_TYPE_DISPLAY = {
    [PAYABLE_TYPE.GENERAL]: 'General',
    [PAYABLE_TYPE.INVOICE]: 'Invoice',
    [PAYABLE_TYPE.EXPENSE]: 'Expense',
    [PAYABLE_TYPE.GRANT]: 'Grant',
    [PAYABLE_TYPE.REFUND]: 'Refund',
    [PAYABLE_TYPE.PAYROLL]: 'Payroll',
    [PAYABLE_TYPE.COMMISSION]: 'Commission',
    [PAYABLE_TYPE.DIVIDEND]: 'Dividend',
    [PAYABLE_TYPE.TAX]: 'Tax',
    [PAYABLE_TYPE.LOAN]: 'Loan',
    [PAYABLE_TYPE.UTILITY]: 'Utility',
};
// #endregion
// #region Payment category IDs (from payment_categories table)
export const PAYMENT_CATEGORY = {
    TRADITIONAL_BANKING: 1,
    DIGITAL_WALLETS: 2,
    CARD_NETWORKS: 3,
    REAL_TIME_RAILS: 4,
    CRYPTOCURRENCY: 5,
    ALTERNATIVE_PAYMENTS: 6,
};
// Reverse mapping: ID -> Key name
export const PAYMENT_CATEGORY_KEYS = {
    1: 'TRADITIONAL_BANKING',
    2: 'DIGITAL_WALLETS',
    3: 'CARD_NETWORKS',
    4: 'REAL_TIME_RAILS',
    5: 'CRYPTOCURRENCY',
    6: 'ALTERNATIVE_PAYMENTS',
};
// Human-readable display names
export const PAYMENT_CATEGORY_DISPLAY = {
    [PAYMENT_CATEGORY.TRADITIONAL_BANKING]: 'Traditional Banking',
    [PAYMENT_CATEGORY.DIGITAL_WALLETS]: 'Digital Wallets',
    [PAYMENT_CATEGORY.CARD_NETWORKS]: 'Card Networks',
    [PAYMENT_CATEGORY.REAL_TIME_RAILS]: 'Real-Time Rails',
    [PAYMENT_CATEGORY.CRYPTOCURRENCY]: 'Cryptocurrency',
    [PAYMENT_CATEGORY.ALTERNATIVE_PAYMENTS]: 'Alternative Payments',
};
// #endregion
// #region Payment method IDs (from payment_methods table)
export const PAYMENT_METHOD = {
    ACH: 1,
    ACH_PLUS: 2,
    WIRE_DOMESTIC: 3,
    WIRE_INTERNATIONAL: 4,
    RTP: 5,
    FEDNOW: 6,
    CHECK: 10,
    CASH: 11,
    VIRTUAL_CARD: 20,
    SECURE_CARD: 21,
    PREPAID_CARD: 22,
    MASTERCARD_CREDIT: 30,
    MASTERCARD_DEBIT: 31,
    DIGITAL_WALLET: 40,
    PAYPAL: 41,
    APPLE_PAY: 42,
    GOOGLE_PAY: 43,
    VENMO: 44,
};
// Reverse mapping: ID -> Key name
export const PAYMENT_METHOD_KEYS = {
    1: 'ACH',
    2: 'ACH_PLUS',
    3: 'WIRE_DOMESTIC',
    4: 'WIRE_INTERNATIONAL',
    5: 'RTP',
    6: 'FEDNOW',
    10: 'CHECK',
    11: 'CASH',
    20: 'VIRTUAL_CARD',
    21: 'SECURE_CARD',
    22: 'PREPAID_CARD',
    30: 'MASTERCARD_CREDIT',
    31: 'MASTERCARD_DEBIT',
    40: 'DIGITAL_WALLET',
    41: 'PAYPAL',
    42: 'APPLE_PAY',
    43: 'GOOGLE_PAY',
    44: 'VENMO',
};
// Human-readable display names
export const PAYMENT_METHOD_DISPLAY = {
    [PAYMENT_METHOD.ACH]: 'ACH',
    [PAYMENT_METHOD.ACH_PLUS]: 'ACH Plus',
    [PAYMENT_METHOD.WIRE_DOMESTIC]: 'Wire Domestic',
    [PAYMENT_METHOD.WIRE_INTERNATIONAL]: 'Wire International',
    [PAYMENT_METHOD.RTP]: 'RTP',
    [PAYMENT_METHOD.FEDNOW]: 'FedNow',
    [PAYMENT_METHOD.CHECK]: 'Check',
    [PAYMENT_METHOD.CASH]: 'Cash',
    [PAYMENT_METHOD.VIRTUAL_CARD]: 'Virtual Card',
    [PAYMENT_METHOD.SECURE_CARD]: 'Secure Card',
    [PAYMENT_METHOD.PREPAID_CARD]: 'Prepaid Card',
    [PAYMENT_METHOD.MASTERCARD_CREDIT]: 'Mastercard Credit',
    [PAYMENT_METHOD.MASTERCARD_DEBIT]: 'Mastercard Debit',
    [PAYMENT_METHOD.DIGITAL_WALLET]: 'Digital Wallet',
    [PAYMENT_METHOD.PAYPAL]: 'PayPal',
    [PAYMENT_METHOD.APPLE_PAY]: 'Apple Pay',
    [PAYMENT_METHOD.GOOGLE_PAY]: 'Google Pay',
    [PAYMENT_METHOD.VENMO]: 'Venmo',
};
// #endregion
// #region Payment network IDs (from payment_networks table)
export const PAYMENT_NETWORK = {
    US_ACH: 1,
    US_FEDWIRE: 2,
    SWIFT_WIRE: 3,
    DIGITAL_WALLET: 10,
    PAYPAL_NETWORK: 11,
    APPLE_PAY: 12,
    GOOGLE_PAY: 13,
    VENMO: 14,
    GENERIC_CARD: 20,
    VISA: 21,
    MASTERCARD: 22,
    AMERICAN_EXPRESS: 23,
    DISCOVER: 24,
    FEDNOW: 30,
    RTP_CLEARINGHOUSE: 31,
};
// #endregion
export const PHONE_TYPE = {
    BUSINESS_MAIN: 1,
    BUSINESS_FAX: 2,
};
export const STATE_PROVINCE = {
    AL_US: 1,
    AK_US: 2,
    AZ_US: 3,
    AR_US: 4,
    CA_US: 5,
    CO_US: 6,
    CT_US: 7,
    DE_US: 8,
    DC_US: 9,
    FL_US: 10,
    GA_US: 11,
    HI_US: 12,
    ID_US: 13,
    IL_US: 14,
    IN_US: 15,
    IA_US: 16,
    KS_US: 17,
    KY_US: 18,
    LA_US: 19,
    ME_US: 20,
    MD_US: 21,
    MA_US: 22,
    MI_US: 23,
    MN_US: 24,
    MS_US: 25,
    MO_US: 26,
    MT_US: 27,
    NE_US: 28,
    NV_US: 29,
    NH_US: 30,
    NJ_US: 31,
    NM_US: 32,
    NY_US: 33,
    NC_US: 34,
    ND_US: 35,
    OH_US: 36,
    OK_US: 37,
    OR_US: 38,
    PA_US: 39,
    RI_US: 40,
    SC_US: 41,
    SD_US: 42,
    TN_US: 43,
    TX_US: 44,
    UT_US: 45,
    VT_US: 46,
    VA_US: 47,
    WA_US: 48,
    WV_US: 49,
    WI_US: 50,
    WY_US: 51,
    PR_US: 52,
    VI_US: 53,
    GU_US: 54,
    AS_US: 55,
    MP_US: 56,
    AB_CA: 57,
    BC_CA: 58,
    MB_CA: 59,
    NB_CA: 60,
    NL_CA: 61,
    NS_CA: 62,
    ON_CA: 63,
    PE_CA: 64,
    QC_CA: 65,
    SK_CA: 66,
    NT_CA: 67,
    NU_CA: 68,
    YT_CA: 69,
    AGU_MX: 70,
    BCN_MX: 71,
    BCS_MX: 72,
    CAM_MX: 73,
    CHP_MX: 74,
    CHH_MX: 75,
    COA_MX: 76,
    COL_MX: 77,
    DIF_MX: 78,
    DUR_MX: 79,
    GUA_MX: 80,
    GRO_MX: 81,
    HID_MX: 82,
    JAL_MX: 83,
    MEX_MX: 84,
    MIC_MX: 85,
    MOR_MX: 86,
    NAY_MX: 87,
    NLE_MX: 88,
    OAX_MX: 89,
    PUE_MX: 90,
    QUE_MX: 91,
    ROO_MX: 92,
    SLP_MX: 93,
    SIN_MX: 94,
    SON_MX: 95,
    TAB_MX: 96,
    TAM_MX: 97,
    TLA_MX: 98,
    VER_MX: 99,
    YUC_MX: 100,
    ZAC_MX: 101,
    NSW_AU: 102,
    QLD_AU: 103,
    SA_AU: 104,
    TAS_AU: 105,
    VIC_AU: 106,
    WA_AU: 107,
    ACT_AU: 108,
    NT_AU: 109,
    BW_DE: 110,
    BY_DE: 111,
    BE_DE: 112,
    BB_DE: 113,
    HB_DE: 114,
    HH_DE: 115,
    HE_DE: 116,
    MV_DE: 117,
    NI_DE: 118,
    NW_DE: 119,
    RP_DE: 120,
    SL_DE: 121,
    SN_DE: 122,
    ST_DE: 123,
    SH_DE: 124,
    TH_DE: 125,
    AC_BR: 126,
    AL_BR: 127,
    AP_BR: 128,
    AM_BR: 129,
    BA_BR: 130,
    CE_BR: 131,
    DF_BR: 132,
    ES_BR: 133,
    GO_BR: 134,
    MA_BR: 135,
    MT_BR: 136,
    MS_BR: 137,
    MG_BR: 138,
    PA_BR: 139,
    PB_BR: 140,
    PR_BR: 141,
    PE_BR: 142,
    PI_BR: 143,
    RJ_BR: 144,
    RN_BR: 145,
    RS_BR: 146,
    RO_BR: 147,
    RR_BR: 148,
    SC_BR: 149,
    SP_BR: 150,
    SE_BR: 151,
    TO_BR: 152,
};
export const VERIFICATION_METHOD = {};
export const ENTITY_TYPE_CODE = {
    PARTY: 'PARTY',
};
export const SETTING_CODE = {
    SUPPLIER_PREFERRED_PAYMENT_METHOD: 'supplier_preferred_payment_method',
};
export const PROVIDER_ERROR_CODE = {
    HAS_ACTIVE_RELATIONSHIPS: 'PROVIDER_HAS_ACTIVE_RELATIONSHIPS',
};
export const PARTNER_ERROR_CODE = {
    HAS_ACTIVE_RELATIONSHIPS: 'PARTNER_HAS_ACTIVE_RELATIONSHIPS',
};
export const RECONCILIATION_STATUS = {
    PARSED: 168,
    FAILED: 169,
};
//# sourceMappingURL=db-constants.js.map